import { gql } from '@apollo/client';

/**
 * Backend exposes a single `subscribe` subscription for all entity types.
 * Returns minimal metadata: { type, _id, mutation, subMutation, teamId, subType, engage }.
 * Client filters by `type` arg or in the subscription handler.
 *
 * @see optisigns-open-api/src/app/pubsub/pubsub.resolver.ts
 */
export const REALTIME_SUBSCRIPTION = gql`
  subscription RealtimeUpdates($teamId: String, $type: OBJECT_TYPES) {
    subscribe(teamId: $teamId, type: $type) {
      type
      _id
      mutation
      subMutation
      teamId
      subType
      engage
    }
  }
`;
